<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <div class="position">
      <div class="bg-white p-20">
        <div class="feedback-main">
          <v-form
            ref="form"
            @submit.prevent="validateForm"
          >
            <div class="feedback-head" :class="{ invalid: $v.feedback.appealType.$error }">
              <v-radio-group v-model="feedback.appealType">
                <v-radio
                  v-for="type in appealTypes"
                  :key="type.id"
                  :label="type.transName"
                  :value="type.id"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="feedback-body">
              <div class="feedback-item">
                <h4>{{$t("Данные заявителя")}}</h4>
                <v-radio-group v-model="feedback.applicantType" @click="validateForm">
                  <v-radio
                    v-for="t in applicantTypes"
                    :key="t.id"
                    :label="t.transName"
                    :value="t.id"
                  ></v-radio>
                </v-radio-group>
                <div
                  v-if="feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row"
                       :class="{ invalid: ($v.feedback.inn.$error && feedback.applicantType == this.legalEntity) || ($v.feedback.inn.$error && !$v.feedback.inn.minLength && feedback.applicantType == this.legalEntity) }">
                    <div class="col-sm-3">
                      <label for="inn">
                        {{ $t("ИНН") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="inn"
                        v-model="feedback.inn"
                        outlined
                        rounded
                        dense
                        name="appeal[inn]"
                        type="number"
                        maxlength="14"
                      ></v-text-field>
                      <small
                        class="helper-text invalid"
                        v-if="(feedback.applicantType === this.legalEntity && $v.feedback.inn.$error && !$v.feedback.inn.minLength) || ($v.feedback.inn.$error && !$v.feedback.inn.maxLength && feedback.applicantType === this.legalEntity)"
                      >
                        {{ $t("Поле должно содержать 14 символов") }}. {{ $t("Сейчас он") }} {{ feedback.inn.length }}
                      </small>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row"
                       :class="{ invalid: ($v.feedback.formOfIncorporation.$error && feedback.applicantType === this.legalEntity) }">
                    <div class="col-sm-3">
                      <label for="formOfIncorporation">
                        {{ $t("Организационно-правовая форма") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-select
                        id="formOfIncorporation"
                        item-value="id"
                        item-text="transName"
                        v-model="feedback.formOfIncorporation"
                        :items="formOfIncorporations"
                        input="transName"
                        outlined
                        rounded
                        dense
                      ></v-select>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row" :class="{ invalid: ($v.feedback.name.$error && feedback.applicantType === this.legalEntity) }">
                    <div class="col-sm-3">
                      <label for="name">
                        {{ $t("Наименование") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="name"
                        v-model="feedback.name"
                        outlined
                        rounded
                        dense
                        name="appeal[name]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="address">
                        {{ $t("Адрес") }}
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="address"
                        v-model="feedback.address"
                        outlined
                        rounded
                        dense
                        name="appeal[address]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="position">
                        {{ $t("Должность") }}
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="position"
                        v-model="feedback.position"
                        outlined
                        rounded
                        dense
                        name="appeal[position]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.individual || feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row" :class="{ invalid: $v.feedback.secondName.$error }">
                    <div class="col-sm-3">
                      <label for="secondName">
                        {{ $t("Фамилия") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="secondName"
                        v-model="feedback.secondName"
                        outlined
                        rounded
                        dense
                        name="appeal[secondName]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.individual || feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row" :class="{ invalid: $v.feedback.firstName.$error }">
                    <div class="col-sm-3">
                      <label for="firstName">
                        {{ $t("Имя") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="firstName"
                        v-model="feedback.firstName"
                        outlined
                        rounded
                        dense
                        name="appeal[firstName]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.individual || feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="lastName">
                        {{ $t("Отчество") }}
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="lastName"
                        v-model="feedback.lastName"
                        outlined
                        rounded
                        dense
                        name="appeal[lastName]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.individual || feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row"
                       :class="{ invalid: $v.feedback.email.$error || ($v.feedback.email.$error && !$v.feedback.email.email) }">
                    <div class="col-sm-3">
                      <label for="email">
                        {{ $t("E-mail") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="email"
                        v-model="feedback.email"
                        outlined
                        rounded
                        dense
                        name="appeal[email]"
                      ></v-text-field>
                      <small
                        class="helper-text invalid"
                        v-if="$v.feedback.email.$error && !$v.feedback.email.email"
                      >
                        {{ $t("Неверный e-mail. Попробуйте еще") }}
                      </small>
                    </div>
                  </div>
                </div>
                <div
                  v-if="feedback.applicantType === this.individual || feedback.applicantType === this.legalEntity"
                  class="form-group"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <label for="phone">
                        {{ $t("Телефон") }}
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-text-field
                        id="phone"
                        v-model="feedback.phone"
                        outlined
                        rounded
                        dense
                        name="appeal[phone]"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="feedback-item">
                <h4>{{$t("Обращение")}}</h4>
                <div class="form-group">
                  <div class="row" :class="{ invalid: $v.feedback.whom.$error }">
                    <div class="col-sm-3">
                      <label for="whom">
                        {{ $t("Кому") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-autocomplete
                        id="whom"
                        item-value="id"
                        item-text="transName"
                        v-model="feedback.whom"
                        :items="developers"
                        input="transName"
                        outlined
                        rounded
                        dense
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-icon class="select-def__icon">
                            <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                            {{ item.transName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                      </v-autocomplete>
                      <small class="helper-text" v-if="feedback.whom != developerJustice">{{$t("Копия: Министерство юстиции КР")}}</small>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row" :class="{ invalid: $v.feedback.text.$error }">
                    <div class="col-sm-3">
                      <label for="text">
                        {{ $t("Текст обращения") }}
                        <span class="asterix">*</span>
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <v-textarea
                        v-model="feedback.text"
                        outlined
                        auto-grow
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group form-files">
                  <div class="row">
                    <div class="col-sm-3">
                      <label>
                        {{ $t("Файлы") }}
                      </label>
                      <fieldInfo/>
                    </div>
                    <div class="col-sm-9">
                      <div class="files">
                        <Files v-bind:files.sync="uploadedFiles"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="feedback-footer">
              <div class="form-captcha">
                <vue-recaptcha
                  ref="recaptcha"
                  size="invisible"
                  :sitekey="sitekey"
                  @verify="createAppeal"
                  @expired="onCaptchaExpired"
                />
              </div>
              <div class="form-group form-action">
                <button
                  class="btn btn-default white"
                  type="button"
                  @click="onCancel"
                >
                  {{ $t("Отмена") }}
                </button>
                <button class="btn btn-default blue" type="submit" value="1">
                  {{ $t("Отправить обращение") }}
                </button>
              </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Appeal from '@/model/appeal'
  import {mapMutations} from 'vuex'
  import fieldInfo from '@/components/app/fieldInfo'
  import {email, required, minLength, maxLength, requiredIf} from 'vuelidate/lib/validators'
  import Files from '@/components/appeal/Files'
  import VueRecaptcha from 'vue-recaptcha'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      fieldInfo,
      Files,
      VueRecaptcha
    },
    mounted() {
      this.fetchData()
      this.scrollToTop()
    },
    computed: {
      applicantType() {
        return this.feedback.applicantType
      }
    },
    data() {
      return {
        feedback: {
          applicantType: null
        },
        sitekey: process.env.VUE_APP_RECAPTCHA_TOKEN,
        breadcrumbs: [],
        appealTypes: [],
        applicantTypes: [],
        developers: [],
        formOfIncorporations: [],
        uploadedFiles: [],
        individual: null,
        legalEntity: null,
        developerJustice: null,
        rules: {
          feedback: {
            appealType: {required},
            firstName: {required},
            secondName: {required},
            email: {required, email},
            whom: {required},
            text: {required},
            inn: {
              required: requiredIf(function () {
                return this.applicantType === this.legalEntity
              }),
              minLength: minLength(14),
              maxLength: maxLength(14),
            },
            formOfIncorporation: {
              required: requiredIf(function () {
                return this.applicantType === this.legalEntity
              })
            },
            name: {
              required: requiredIf(function () {
                return this.applicantType === this.legalEntity
              })
            }
          }
        }
      }
    },
    metaInfo () {
      return {
        title: this.$i18n.t('FeedbackTitleSEO'),
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.$i18n.t('FeedbackDescriptionSEO'),
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('FeedbackKeywordsSEO'),
        }]
      }
    },
    validations() {
      return this.rules
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        Appeal.getAppealFormData().then((response) => {
          this.appealTypes = response.data.appealTypes
          this.applicantTypes = response.data.applicantTypes
          this.developers = response.data.developers
          this.formOfIncorporations = response.data.formOfIncorporations
          this.individual = response.data.individual
          this.legalEntity = response.data.legalEntity
          this.developerJustice = response.data.developerJustice
          this.feedback.applicantType = response.data.individual
          this.feedback.lastName = response.data.lastName
          this.feedback.firstName = response.data.firstName
          this.feedback.secondName = response.data.secondName
          this.feedback.email = response.data.email
          this.feedback.phone = response.data.phone
          this.generateBreadcrumbs()
          this.setLoading(false)
        }).catch((error) => {
          this.setLoading(false)
          console.log(error)
        })
      },
      // генерация хлебных крошек
      generateBreadcrumbs() {
        this.breadcrumbs = [
          {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
          {text: this.$i18n.t('Отправить обращение'), disabled: true},
        ]
      },
      // Валидация формы
      validateForm() {
        this.$v.$touch()

        if (this.$v.$invalid) {
          this.$nextTick(() => {
            this.scrollToFirstError()
          })

          return false
        }

        this.$refs.recaptcha.execute()
        return true
      },
      // Создание
      createAppeal(recaptchaToken) {
        if (!this.validateForm()) {
          return
        }

        const f = this.$refs.form.$el
        const fd = new FormData(f)

        fd.append('appeal[appealType]', this.feedback.appealType)
        fd.append('appeal[applicantType]', this.feedback.applicantType)
        fd.append('appeal[text]', this.feedback.text)
        fd.append('appeal[firstName]', this.feedback.firstName)
        fd.append('appeal[secondName]', this.feedback.secondName)
        fd.append('appeal[whom]', this.feedback.whom)
        fd.append('appeal[email]', this.feedback.email)
        if (this.feedback.lastName) fd.append('appeal[lastName]', this.feedback.lastName)
        if (this.feedback.phone) fd.append('appeal[phone]', this.feedback.phone)
        if (this.feedback.applicantType === 2) {
          fd.append('appeal[inn]', this.feedback.inn)
          fd.append('appeal[name]', this.feedback.name)
          if (this.feedback.address) fd.append('appeal[address]', this.feedback.address)
          if (this.feedback.position) fd.append('appeal[position]', this.feedback.position)
          if (this.feedback.formOfIncorporation) fd.append('appeal[formOfIncorporation]', this.feedback.formOfIncorporation)
        }
        fd.append('appeal[applicantType]', this.feedback.applicantType)
        this.uploadedFiles.forEach(function (element, index) {
          fd.append(`appeal[uploadedFiles][${index}][uploadedFile]`, element)
        })

        this.setLoading(true)
        Appeal.createAppeal(fd, recaptchaToken).then((response) => {
          if (response.status === 201) {
            this.setLoading(false)
            this.$router.push(Trans.i18nRoute({
              name: 'feedback-success',
              params: {
                id: response.data.appeal.id
              }
            }))
          }
        }).catch((error) => {
          this.setLoading(false)
          if (error.response.status === 409) {
            this.$noty.error(this.$i18n.t(error.response.data.message), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            return
          }
        })
      },
      onCaptchaExpired() {
        this.$refs.recaptcha.reset()
      },
      onCancel() {
        this.$router.push(Trans.i18nRoute({name: 'home'}))
      },
      // Прокручивание до поля с ошибкой
      scrollToFirstError() {
        const domRect = document.querySelector('.invalid').getBoundingClientRect()
        window.scrollTo(
          domRect.left +
          (document.body.scrollLeft || document.documentElement.scrollLeft),
          domRect.top +
          (document.body.scrollTop || document.documentElement.scrollTop) -
          90
        )
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .col-sm-2,
  .col-sm-3,
  .col-sm-9,
  .col-sm-10 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .form-files {
    label {
      min-width: auto;
    }
  }

  .files {
    .file-item {
      display: flex;

      i {
        position: relative;
        top: -4px;
      }

      .v-input {
        max-width: 240px;
        margin: 0;
        padding: 0;
        white-space: nowrap;
      }
    }
  }
</style>
